// import { messages as zhCN } from './zh-CN.po';
import { messages as zhTW } from './zh-TW.po';

export const locales = {
  // 'zh-CN': zhCN,
  'zh-TW': zhTW,
  'zh-Hant': zhTW,
  'zh-Hant-CN': zhTW,
  'zh-Hant-TW': zhTW,
  'zh-Hant-MO': zhTW,
};

export const getLang = (lang: string) => {
  // 全都使用繁體中文
  return 'zh-TW';
  // return lang in locales ? lang : 'zh-TW';
};
